import React, { useContext, useEffect, useState } from 'react';
import { FormElement, DragHandle, FormSelector, FormLabel, FormNumberInput } from "../components/StyledElements";
import { Handle, Position } from '@xyflow/react';
import { NodeCard } from './NodeCard';
import { CloseButton } from '../components/CloseButton';
import swal from "sweetalert2";
import { useDataSets } from '../contexts/DataSetsContext';
import { AppContext } from '../contexts/AppContext';
import { getDataSets } from 'services/data';

export const DataSetNodeCard = ({ onAdd = () => { }, style = {} }) => {
  return (
    <NodeCard title="Data Set" description="Find records from datasets that are the closest matches to the input" onAdd={() => onAdd(250, 100)} style={style} />
  )
};

export const DataSetNode = ({ id, data }) => {
  console.log("!!! DataSet NODE DATA: ", data);
  const { dataSets, setDataSets } = useDataSets();
  const { selectedClient } = useContext(AppContext);
  const [localData, setLocalData] = useState({
    dataSet: "",
    documentCount: 5,
  });
  const [dataSetOptions, setDataSetOptions] = useState([]);
  const [dataSetDescriptions, setDataSetDescriptions] = useState({});
  console.log("!!! Datasets: ", dataSets);

  useEffect(() => {
    console.log("!!! FETCHING data SETS");
    const fetchDataSets = async () => {
      try {
        const results = await getDataSets(selectedClient.id);
        if (results.success) {
          console.log("!!! FETCHED DataSets: ", results.data_sets);
          setDataSets(results.datasets);

          const options = [{
            value: "",
            label: "Select a dataSet",
          }, ...results.data_sets.map((dataset) => ({
            value: dataset.public_id,
            label: dataset.name,
          }))];
          setDataSetOptions(options);

          const descriptions = {};
          results.data_sets.forEach((dataSet) => {
            descriptions[dataSet.public_id] = dataSet.description;
          });
          setDataSetDescriptions(descriptions);
        } else {
          swal.fire({
            title: "Error fetching dataSets",
            text: results.message || "An error occurred while fetching dataSets. Please try again later.",
            icon: "error",
            confirmButtonText: "OK"
          });
        }
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM users: ", selectedClient);
    if (selectedClient) {
      fetchDataSets();
    }
    // eslint-disable-next-line
  }, [selectedClient]);

  useEffect(() => {
    if (!data) {
      return;
    }
    setLocalData({
      dataSet: data.dataSet,
      documentCount: data.documentCount,
    });
  }, [data]);

  return (
    <div style={{ position: "relative", display: "flex", flexDirection: "column", padding: "10px", border: "1px solid var(--main-border-color)", borderRadius: "8px", backgroundColor: "var(--content-item-bg)" }}>
      <CloseButton onClick={() => {
        data.onDelete(id);
      }} />
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <DragHandle />
        <FormLabel label="DataSet" />
        <FormElement>
          <FormLabel label="Document Count" />
          <FormNumberInput
            value={localData?.documentCount ?? 5}
            onChange={(e) => {
              console.log("!!! DOCUMENT COUNT CHANGE: ", e.target.value, typeof e.target.value);
              setLocalData({ ...localData, documentCount: e.target.value });
              data.onUpdateData(id, { documentCount: e.target.value });
            }}
            min={1}
            step={1}
          />
        </FormElement>
        <FormElement>
          <div style={{ width: "100%", fontSize: "14px", color: "var(--main-font-color)", marginBottom: "10px" }} title="
            Choose a dataSet to execute. The input data will be passed to the dataSet and the output of the dataSet will be passed to the next node.">
            Info
        </div>
          <FormSelector
            value={localData?.dataSet ?? ""}
            options={dataSetOptions}
            onChange={(e) => {
              console.log("!!! dataSet CHANGE: ", e.target.value);
              setLocalData({ ...localData, dataSet: e.target.value });
              data.onUpdateData(id, { dataSet: e.target.value });
            }}
          />
        </FormElement>
        <div style={{ width: "100%", fontSize: "14px", color: "var(--main-font-color)", marginBottom: "10px" }}>
          {localData?.dataSet && dataSetDescriptions[localData?.dataSet] ? dataSetDescriptions[localData.dataSet] : "No description available for this dataSet."}
        </div>

      </div>
      <Handle type="target" position={Position.Left} style={{ height: "12px", width: "12px" }} />
      <Handle type="source" position={Position.Right} style={{ height: "12px", width: "12px" }} id="dataSet-input" />
    </div>
  );
};

export default DataSetNode;
